module.exports = __webpack_public_path__ + "76ef240b5ed4a194ccf7d600c18311a6.svg";